module.exports = __webpack_public_path__ + "static/media/projects-main-image.625dc79e.png";